/**
 * Enum group column Khóa sổ kỳ kế toán
 */
export default {
  Post: 1, // Ghi sổ
  ChangePostedDate: 2, // Chuyển ngày HT
  Delete: 3, // Xóa
};
